import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb9644d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "title"]
const _hoisted_2 = { class: "button-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { computed, inject, PropType } from 'vue';
import { useStore } from 'vuex';
import { Photo } from '@/models';
import { ReportsState } from '@/store/reports/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'Photo',
  props: {
  photo: { type: Object as PropType<Photo>},
  galleryType: { type: String },
  isLogo: { type: Boolean, default: false  },
  showdeletebutton: { type: Boolean, default: true  },
  showrotatebutton: { type: Boolean, default: true  },
},
  emits: ['rotate', 'delete'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const store = useStore();

// Props
const props = __props;

// Defaults for optional props
const isLogo = props.isLogo ?? false;

// Injects
const actProperty: any = inject('actProperty');

// Methods
const onRotate = (event: Event) => {
  emit('rotate', props.photo);
};

const onDelete = (event: Event) => {
  emit('delete', props.photo);
};

const openPhotoInGallery = () => {
  if (props.isLogo) return;
  const url = actProperty.photoGalleryUrl(
    props.photo,
    store.state.reports.current,
    props.galleryType
  );
  window.open(url, "_blank");
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-preview", { logo: _unref(isLogo) }])
  }, [
    _createElementVNode("a", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openPhotoInGallery()), ["stop"])),
      class: "photo-link"
    }, [
      _createElementVNode("img", {
        src: _unref(actProperty).resizedPhotoSrc(__props.photo),
        alt: _unref(actProperty).formatDatetimeForDisplay(__props.photo.createdAt),
        title: _unref(actProperty).formatDatetimeForDisplay(__props.photo.createdAt)
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        (__props.showdeletebutton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm btn-danger",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onDelete()), ["stop"]))
            }, _hoisted_4))
          : _createCommentVNode("", true),
        (!_unref(isLogo) && __props.showrotatebutton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-sm btn-info rotate-btn-clockwise",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onRotate()), ["stop"]))
            }, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})